import { isEmpty } from 'lodash-es'

import { EmbroiderableProductEmbroideryRestrictions } from '../../../types/graphql/product'
import { EmbroideryColor, EmbroideryFont, useEmbroideryDesignsQuery } from '../useEmbroideryDesigns'

export const isEmbroideryColorAllowedForProduct = ({
  colorKey,
  productEmbroideryConfig,
}: {
  colorKey: string
  productEmbroideryConfig: EmbroiderableProductEmbroideryRestrictions
}) => {
  if (isEmpty(productEmbroideryConfig.colorRestrictions)) return true
  return !!productEmbroideryConfig.colorRestrictions.find(color => color.key === colorKey)
}

export const useRestrictedEmbroideryFonts = (
  fontRestrictions: { key: string }[] | null | undefined
): EmbroideryFont[] => {
  const { data } = useEmbroideryDesignsQuery()
  const fonts = data?.embroideryOptions.fonts ?? []
  return fonts.filter(font => {
    return (
      !fontRestrictions ||
      isEmpty(fontRestrictions) ||
      fontRestrictions.find(fontRestriction => fontRestriction.key === font.key)
    )
  })
}

export const useRestrictedEmbroideryColors = (
  colorRestrictions: { key: string }[] | null | undefined
): EmbroideryColor[] => {
  const { data } = useEmbroideryDesignsQuery()
  const colors = data?.embroideryOptions.colors ?? []
  return colors.filter(color => {
    return (
      !colorRestrictions ||
      isEmpty(colorRestrictions) ||
      colorRestrictions.find(colorRestriction => colorRestriction.key === color.key)
    )
  })
}
